import React, { useState, useEffect } from 'react';
import {
  Drawer, List, ListItemButton, ListItemIcon, ListItemText,
  Collapse, Box, Typography, Divider, IconButton, Tooltip
} from '@mui/material';
import {
  Dashboard, ExpandLess, ExpandMore, DirectionsCar, People,
  Business, Assignment, Insights, HelpOutline, MenuBook,
  Menu, LocalOffer, Gavel, AccountBalance, AccountBalanceWallet,
  Payment, MonetizationOn, BarChart, Assessment, Build, Description,
  Settings, CalendarMonth, BookOnline, Person, FolderOpen, ImageSearch
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import './sidebar.css';
import Logo from './logo.png';


export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [openCadastros, setOpenCadastros] = useState(false);
  const [openControle, setOpenControle] = useState(false);
  const [openFinanceiro, setOpenFinanceiro] = useState(false);
  const [openMultas, setOpenMultas] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [permissao, setPermissao] = useState('');


  useEffect(() => {
    async function buscarPermissaoUsuario() {
      try {
        const token = localStorage.getItem('token');
        const resposta = await fetch(`${process.env.REACT_APP_API_URL}/usuario/me`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
  
        if (resposta.ok) {
          const dados = await resposta.json();
          setPermissao(dados.permissao || '');
        } else {
          console.error('Erro ao buscar permissão do usuário');
        }
      } catch (error) {
        console.error('Erro no servidor:', error.message);
      }
    }
  
    buscarPermissaoUsuario();
  }, []);
  
  const toggleCollapse = () => setCollapsed(!collapsed);
  const iconColor = '#FF8C00';

  const isActive = (path) => location.pathname === path;

  const navItem = (icon, label, path, onClick = null) => (
    <Tooltip title={collapsed ? label : ''} placement="right" arrow>
      <ListItemButton
        selected={isActive(path)}
        onClick={() => {
          onClick ? onClick() : navigate(path);
        }}
        sx={{
          px: 2,
          py: 1.2,
          borderLeft: isActive(path) ? '4px solid #FF8C00' : '4px solid transparent',
          '&:hover': {
            backgroundColor: 'rgba(255,140,0,0.1)',
            borderLeft: '4px solid #FF8C00',
          },
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <ListItemIcon sx={{ color: iconColor }}>{icon}</ListItemIcon>
        {!collapsed && <ListItemText primary={label} sx={{ color: '#fff' }} />}
      </ListItemButton>
    </Tooltip>
  );

  return (
    <Drawer
  variant="permanent"
  sx={{
    width: collapsed ? 72 : 240,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: collapsed ? 72 : 240,
      transition: 'width 0.3s ease-in-out',
    },
  }}
  classes={{ paper: 'sidebar-glass' }}
>

      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        
        
        <Box
  className="sidebar-logo"
  sx={{
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: 2,
    px: 1,
  }}
>
  <img
    src={Logo}
    alt="Logo EASY"
    style={{
      width: collapsed ? 48 : 100,
      transition: 'all 0.3s ease',
    }}
  />

  <IconButton onClick={toggleCollapse} sx={{ mt: 1 }}>
    <Menu sx={{ color: '#FF8C00' }} />
  </IconButton>
</Box>



        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)' }} />

        {/* MENU */}
        <List component="nav" disablePadding>
          {navItem(<Dashboard />, 'Dashboard', '/dashboard')}

          <Tooltip title={collapsed ? 'Cadastros' : ''} placement="right" arrow>
            <ListItemButton
              onClick={() => setOpenCadastros(!openCadastros)}
              sx={{
                px: 2,
                py: 1.2,
                borderLeft: '4px solid transparent',
                '&:hover': {
                  backgroundColor: 'rgba(255,140,0,0.1)',
                  borderLeft: '4px solid #FF8C00',
                },
                transition: 'all 0.3s ease-in-out',
              }}
            >
              <ListItemIcon sx={{ color: iconColor }}>
                <MenuBook />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Cadastros" sx={{ color: '#fff' }} />}
              {!collapsed && (openCadastros ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </Tooltip>

          <Collapse in={openCadastros && !collapsed} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: collapsed ? 0 : 2 }}>
              <ListItemButton
                selected={isActive('/cadastros/veiculos')}
                onClick={() => navigate('/cadastros/veiculos')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <DirectionsCar fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Veículos" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/cadastros/clientes')}
                onClick={() => navigate('/cadastros/clientes')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <People fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Clientes" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/cadastros/promocoes')}
                onClick={() => navigate('/cadastros/promocoes')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <LocalOffer fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Promoções" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/cadastros/fornecedores')}
                onClick={() => navigate('/cadastros/fornecedores')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <Business fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Fornecedores" />}
              </ListItemButton>

              {permissao === 'admin' && (
                <ListItemButton
                  selected={isActive('/cadastros/usuarios')}
                  onClick={() => navigate('/cadastros/usuarios')}
                  sx={{
                    ml: collapsed ? 0 : 1,
                    py: 1,
                    pl: collapsed ? 2 : 4,
                    backgroundColor: 'rgba(255,255,255,0.03)',
                    borderLeft: '4px solid #444',
                    color: '#e0e0e0',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.06)',
                      borderLeft: '4px solid #FF8C00',
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                    <People fontSize="small" />
                  </ListItemIcon>
                  {!collapsed && <ListItemText primary="Usuários" />}
                </ListItemButton>
              )}
            </List>
          </Collapse>

          {/* Submenu Controle */}
          <Tooltip title={collapsed ? 'Controle' : ''} placement="right" arrow>
            <ListItemButton
              onClick={() => setOpenControle(!openControle)}
              sx={{
                px: 2,
                py: 1.2,
                borderLeft: '4px solid transparent',
                '&:hover': {
                  backgroundColor: 'rgba(255,140,0,0.1)',
                  borderLeft: '4px solid #FF8C00',
                },
                transition: 'all 0.3s ease-in-out',
              }}
            >
              <ListItemIcon sx={{ color: iconColor }}>
                <Assignment />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Controle" sx={{ color: '#fff' }} />}
              {!collapsed && (openControle ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </Tooltip>

          <Collapse in={openControle && !collapsed} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: collapsed ? 0 : 2 }}>
              <ListItemButton
                selected={isActive('/alugueis')}
                onClick={() => navigate('/alugueis')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <Assignment fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Aluguéis" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/frotas')}
                onClick={() => navigate('/frotas')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <DirectionsCar fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Frota" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/frotas/manutencoes')}
                onClick={() => navigate('/frotas/manutencoes')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <Build fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Manutenção" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/contratos')}
                onClick={() => navigate('/contratos')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <Description fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Contratos" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/pre-reservas')}
                onClick={() => navigate('/pre-reservas')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <BookOnline fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Pré-Reservas" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/controle/ficha-cliente')}
                onClick={() => navigate('/controle/ficha-cliente')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <Person fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Ficha do Cliente" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/vistorias')}
                onClick={() => navigate('/vistorias')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <ImageSearch fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Vistorias" />}
              </ListItemButton>
            </List>
          </Collapse>

          {/* Submenu Financeiro */}
          <Tooltip title={collapsed ? 'Financeiro' : ''} placement="right" arrow>
            <ListItemButton
              onClick={() => setOpenFinanceiro(!openFinanceiro)}
              sx={{
                px: 2,
                py: 1.2,
                borderLeft: '4px solid transparent',
                '&:hover': {
                  backgroundColor: 'rgba(255,140,0,0.1)',
                  borderLeft: '4px solid #FF8C00',
                },
                transition: 'all 0.3s ease-in-out',
              }}
            >
              <ListItemIcon sx={{ color: iconColor }}>
                <AccountBalance />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Financeiro" sx={{ color: '#fff' }} />}
              {!collapsed && (openFinanceiro ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </Tooltip>

          <Collapse in={openFinanceiro && !collapsed} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: collapsed ? 0 : 2 }}>
              <ListItemButton
                selected={isActive('/cadastros/caixa')}
                onClick={() => navigate('/cadastros/caixa')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <AccountBalanceWallet fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Caixa" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/cadastros/contaspagar')}
                onClick={() => navigate('/cadastros/contaspagar')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <Payment fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Contas a Pagar" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/cadastros/contasreceber')}
                onClick={() => navigate('/cadastros/contasreceber')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <MonetizationOn fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Contas a Receber" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/cadastros/relatorios')}
                onClick={() => navigate('/cadastros/relatorios')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <BarChart fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Relatórios" />}
              </ListItemButton>
            </List>
          </Collapse>

          {/* MULTAS */}
          <Tooltip title={collapsed ? 'Multas' : ''} placement="right" arrow>
            <ListItemButton
              onClick={() => setOpenMultas(!openMultas)}
              sx={{
                px: 2,
                py: 1.2,
                borderLeft: '4px solid transparent',
                '&:hover': {
                  backgroundColor: 'rgba(255,140,0,0.1)',
                  borderLeft: '4px solid #FF8C00',
                },
                transition: 'all 0.3s ease-in-out',
              }}
            >
              <ListItemIcon sx={{ color: iconColor }}>
                <Gavel />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Multas" sx={{ color: '#fff' }} />}
              {!collapsed && (openMultas ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </Tooltip>

          <Collapse in={openMultas && !collapsed} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: collapsed ? 0 : 2 }}>
              <ListItemButton
                selected={isActive('/multas')}
                onClick={() => navigate('/multas')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <Gavel fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Gestão de Multas" />}
              </ListItemButton>

              <ListItemButton
                selected={isActive('/multas/relatorios')}
                onClick={() => navigate('/multas/relatorios')}
                sx={{
                  ml: collapsed ? 0 : 1,
                  py: 1,
                  pl: collapsed ? 2 : 4,
                  backgroundColor: 'rgba(255,255,255,0.03)',
                  borderLeft: '4px solid #444',
                  color: '#e0e0e0',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.06)',
                    borderLeft: '4px solid #FF8C00',
                  },
                }}
              >
                <ListItemIcon sx={{ color: '#FF8C00', minWidth: 32 }}>
                  <Assessment fontSize="small" />
                </ListItemIcon>
                {!collapsed && <ListItemText primary="Relatórios" />}
              </ListItemButton>
            </List>
          </Collapse>

          {navItem(<FolderOpen />, 'Arquivos', '/arquivos')}
          {navItem(<Insights />, 'Relatórios', '/relatorios')}
          {navItem(<CalendarMonth />, 'Calendário de Reservas', '/calendario')}
          {navItem(<DirectionsCar />, 'Análise de Veículos', '/analise-veiculos')}
          {navItem(<Settings />, 'Integrações', '/integracoes')}
          {navItem(<HelpOutline />, 'Instruções', '/instrucoes')}
        </List>
        

        <Box flexGrow={1} />

        {/* RODAPÉ */}
        <Box
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderTop: '1px solid rgba(255,255,255,0.05)',
            mt: 'auto',
          }}
        >
          {!collapsed && (
            <Typography variant="caption" color="white" sx={{ fontSize: 10, opacity: 0.6 }}>
              EASY Locadora © {new Date().getFullYear()}
            </Typography>
          )}
        </Box>

      </Box>
    </Drawer>
  );
}
